import api from '../api';

// Server-side transcription via Groq Whisper (POST /api/voice/transcribe).
// Replaced on-device @huggingface/transformers because the 74MB Whisper model
// OOM-killed iOS Safari tabs when MediaRecorder + WASM were both active.
export async function transcribe(audioBlob, { signal } = {}) {
  const form = new FormData();
  const filename = audioBlob.type?.includes('mp4') ? 'recording.mp4' : 'recording.webm';
  form.append('audio', audioBlob, filename);

  const res = await api.post('/api/voice/transcribe', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    signal,
  });
  return (res.data?.text || '').trim();
}
